/**
 * Coups de pouce — attendu 625 (nature d’une fraction : entier,
 * décimal non entier, non décimal).
 *
 * Méthode = DIVISION POSÉE à la main (exigence utilisateur).
 * Exemples HORS pools : 8/9, 39/3, 9/8 absents des trois pools.
 */

// La potence qui BOUCLE : 8 ÷ 9 posée chiffre par chiffre, le reste 8
// revient (cercles rouges) → la division ne s’arrêtera jamais → non
// décimal. Le pendant « ça s’arrête » est animé chez 620 (FICHE_DECIMALE).
const SVG_POTENCE_BOUCLE = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 160" width="290" height="155" role="img" data-etapes="5"
     aria-label="On pose la division de 8 par 9. Dans 8, il y a 0 fois 9 : quotient 0. On écrit 8 égale 8,0 : la virgule passe au quotient et on abaisse le zéro : 80. Dans 80, il y a 8 fois 9, soit 72 : reste 8. On abaisse encore un zéro : de nouveau 80, de nouveau reste 8. Le même reste revient sans fin : la division ne s’arrêtera jamais, 8 neuvièmes est un nombre non décimal">
  <style>
    .anim { opacity: 1; }
    [data-caption] { opacity: 0; }
    [data-caption="5"] { opacity: 1; }
    @media (prefers-reduced-motion: no-preference) {
      .d1 { opacity: 0; animation: cp625nat 10s linear infinite 0s; }
      .c1 { opacity: 0; animation: cp625natc 10s linear infinite 0s; }
      .d2 { opacity: 0; animation: cp625nat 10s linear infinite 2s; }
      .c2 { opacity: 0; animation: cp625natc 10s linear infinite 2s; }
      .d3 { opacity: 0; animation: cp625nat 10s linear infinite 4s; }
      .c3 { opacity: 0; animation: cp625natc 10s linear infinite 4s; }
      .d4 { opacity: 0; animation: cp625nat 10s linear infinite 6s; }
      .c4 { opacity: 0; animation: cp625natc 10s linear infinite 6s; }
      .d5 { opacity: 0; animation: cp625nat 10s linear infinite 8s; }
      .c5 { opacity: 0; animation: cp625natcf 10s linear infinite 8s; }
    }
    @keyframes cp625nat { 0%, 2% { opacity: 0; } 5%, 96% { opacity: 1; } 98%, 100% { opacity: 0; } }
    @keyframes cp625natc { 0%, 2% { opacity: 0; } 4%, 16% { opacity: 1; } 20%, 100% { opacity: 0; } }
    @keyframes cp625natcf { 0%, 2% { opacity: 0; } 4%, 96% { opacity: 1; } 98%, 100% { opacity: 0; } }
  </style>
  <g class="anim d1" data-etape="1">
    <text x="84" y="30" text-anchor="middle" font-size="15" font-weight="bold" fill="#334155">8</text>
    <line x1="150" y1="14" x2="150" y2="118" stroke="#334155" stroke-width="1.5"/>
    <line x1="150" y1="40" x2="245" y2="40" stroke="#334155" stroke-width="1.5"/>
    <text x="170" y="32" text-anchor="middle" font-size="15" font-weight="bold" fill="#334155">9</text>
    <text x="166" y="62" text-anchor="middle" font-size="15" font-weight="bold" fill="#b45309">0</text>
  </g>
  <g class="anim d2" data-etape="2">
    <text x="175" y="62" text-anchor="middle" font-size="15" font-weight="bold" fill="#b45309">,</text>
    <text x="90" y="30" text-anchor="middle" font-size="15" font-weight="bold" fill="#f97316">,</text>
    <text x="96" y="30" text-anchor="middle" font-size="15" font-weight="bold" fill="#f97316">0</text>
  </g>
  <g class="anim d3" data-etape="3">
    <text x="72" y="48" text-anchor="middle" font-size="13" fill="#334155">−</text>
    <text x="84" y="48" text-anchor="middle" font-size="15" fill="#334155">7</text>
    <text x="96" y="48" text-anchor="middle" font-size="15" fill="#334155">2</text>
    <line x1="66" y1="54" x2="104" y2="54" stroke="#334155" stroke-width="1.2"/>
    <text x="96" y="70" text-anchor="middle" font-size="15" font-weight="bold" fill="#334155">8</text>
    <text x="186" y="62" text-anchor="middle" font-size="15" font-weight="bold" fill="#b45309">8</text>
  </g>
  <g class="anim d4" data-etape="4">
    <text x="108" y="30" text-anchor="middle" font-size="15" font-weight="bold" fill="#f97316">0</text>
    <text x="108" y="70" text-anchor="middle" font-size="15" font-weight="bold" fill="#f97316">0</text>
    <text x="84" y="88" text-anchor="middle" font-size="13" fill="#334155">−</text>
    <text x="96" y="88" text-anchor="middle" font-size="15" fill="#334155">7</text>
    <text x="108" y="88" text-anchor="middle" font-size="15" fill="#334155">2</text>
    <line x1="78" y1="94" x2="116" y2="94" stroke="#334155" stroke-width="1.2"/>
    <text x="108" y="110" text-anchor="middle" font-size="15" font-weight="bold" fill="#334155">8</text>
    <text x="198" y="62" text-anchor="middle" font-size="15" font-weight="bold" fill="#b45309">8</text>
  </g>
  <g class="anim d5" data-etape="5">
    <circle cx="96" cy="65" r="9" fill="none" stroke="#dc2626" stroke-width="2"/>
    <circle cx="108" cy="105" r="9" fill="none" stroke="#dc2626" stroke-width="2"/>
    <path d="M 108 116 C 104 126 96 122 94 112" fill="none" stroke="#dc2626" stroke-width="1.3" stroke-dasharray="3 2"/>
    <text x="212" y="62" text-anchor="middle" font-size="15" font-weight="bold" fill="#dc2626">…</text>
  </g>
  <g class="anim c1" data-caption="1">
    <text x="150" y="146" text-anchor="middle" font-size="11.5" fill="#334155">pose 8 ÷ 9 : dans 8, il y a <tspan font-weight="bold" fill="#b45309">0 fois 9</tspan></text>
  </g>
  <g class="anim c2" data-caption="2">
    <text x="150" y="146" text-anchor="middle" font-size="11.5" fill="#334155">écris <tspan font-weight="bold" fill="#f97316">8 = 8,0</tspan> : virgule au quotient, abaisse le <tspan font-weight="bold" fill="#f97316">0</tspan></text>
  </g>
  <g class="anim c3" data-caption="3">
    <text x="150" y="146" text-anchor="middle" font-size="11.5" fill="#334155">dans 80, il y a <tspan font-weight="bold" fill="#b45309">8 fois 9</tspan> (72) : <tspan font-weight="bold">reste 8</tspan></text>
  </g>
  <g class="anim c4" data-caption="4">
    <text x="150" y="146" text-anchor="middle" font-size="11.5" fill="#334155">abaisse un 0 : <tspan font-weight="bold">encore 80… encore reste 8</tspan></text>
  </g>
  <g class="anim c5" data-caption="5">
    <text x="150" y="146" text-anchor="middle" font-size="11.5" fill="#334155">le <tspan font-weight="bold" fill="#dc2626">même reste revient</tspan> : jamais fini → <tspan font-weight="bold" fill="#dc2626">non décimal</tspan> !</text>
  </g>
</svg>`.trim();

const FICHE_NATURE = {
    pages: [
        {
            titre: 'Pose la division !',
            lignes: [
                'Pour connaître la nature de $\\dfrac{8}{9}$, **pose la division** 8 ÷ 9 au brouillon.',
            ],
            svg: SVG_POTENCE_BOUCLE,
        },
        {
            titre: 'Les trois natures',
            lignes: [
                'La division tombe juste **sans virgule** : 39 ÷ 3 = 13 → **nombre entier**.',
                'Elle s\'arrête **après la virgule** : 9 ÷ 8 = 1,125 → **décimal non entier**.',
                'Le **même reste revient** : 8 ÷ 9 = 0,888… → **non décimal**.',
            ],
        },
    ],
};

// Exacte ou approchée, sobre : exacte = toute la valeur (la division
// s'arrête), approchée = coupée quelque part (arrondi). Exemples 9/8 et
// 8/9 hors pools, cohérents avec la fiche potence.
const FICHE_EXACT = {
    pages: [
        {
            titre: 'Exacte ou approchée ?',
            lignes: [
                '**Exacte**, c\'est lorsque la division **s\'arrête** : $\\dfrac{9}{8} = 1{,}125$, on a écrit *toute* la valeur.',
                '**Approchée**, c\'est lorsque la division **ne s\'arrête jamais** : $\\dfrac{8}{9} \\approx 0{,}89$, on a dû couper : c\'est un **arrondi**.',
                'Pour trancher : **pose la division** et regarde si elle s\'arrête.',
            ],
        },
    ],
};

const CP_625 = {
    nature_qcm: FICHE_NATURE,
    nature_classer: FICHE_NATURE,
    nature_vf: FICHE_NATURE,
    nature_select_decimaux: FICHE_NATURE,
    nature_saisie: FICHE_NATURE,
    nature_methode_drag: FICHE_NATURE,
    nature_exact_approche: FICHE_EXACT,
};

export default CP_625;
